'use strict';

import React from 'react';
import { withFormsy } from 'formsy-react';
import classNames from 'classnames';

class CheckBox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isChecked: false,
        };
    }

    componentDidMount() {
        this.updateElement(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.updateElement(nextProps);
    }

    updateElement = (props) => {

        // set value if a checked prop is passed from parent
        if (props.checked !== null && props.checked !== undefined && props.checked !== this.state.isChecked) {
            this.setValue(props.checked);
        }

        // if element hasn't been updated and initialValue is passed then set to value
        if (this.props.isPristine() && props.initialValue) {
            this.setValue(props.initialValue);
        }
    }

    setValue = (isChecked) => {
        this.props.setValue(isChecked);
        this.setState({
            isChecked,
        });
    }

    changeValue = (event) => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
        const isChecked = event.target.checked;
        this.setValue(isChecked);

        if (this.props.onChange) {
            this.props.onChange(isChecked);
        }
    }

    render() {

        const classes = classNames(
            'fc-checkbox', this.props.className, {
                disabled: this.props.disabled,
                indent: this.props.indent,
            }
        );

        return (
            <div id={'form-element-{0}'.format(this.props.name)} className={classes}>
                <input 
                    formNoValidate
                    name={this.props.name}
                    id={this.props.name}
                    type="checkbox"
                    onChange={this.changeValue}
                    disabled={this.props.disabled}
                    checked={this.state.isChecked}
                />
                <label htmlFor={this.props.name}>{this.props.label}</label>

                {this.props.childComponent ? (
                    <div className="fc-checkbox-child">
                        {React.cloneElement(
                            this.props.childComponent
                        )}
                    </div>
                ) : null}
            </div>
        );
    }
}

export default withFormsy(CheckBox); 
